import request from '@/utils/request'

// 取得APP操作日志列表
export function appLogList(params) {
  return request({
    url: '/appLog/appLogList',
    method: 'get',
    params,
  })
}

// 取得历程监控表
export function sysLogList(params) {
  return request({
    url: '/sysLog/list',
    method: 'get',
    params,
  })
}

// 取得操作日志
export function getMonitorList(params) {
  return request({
    url: '/monitor/list',
    method: 'get',
    params: params,
  })
}

// 操作历程彙整
export function getOperationAuditData(params) {
  return request({
    url: '/sysLog/getOperationAuditData',
    method: 'get',
    params: params,
  })
}

// 操作历程支援支援类型
export function getOperationAuditDataOpCode(params) {
  return request({
    url: '/sysLog/getOperationAuditDataOpCode',
    method: 'get',
    params: params,
  })
}


// WEBPACK FOOTER //
// ./src/api/monitor.js